export default "__VITE_ASSET__HSFfaRo8__"